import { render, staticRenderFns } from "./project-card.component.vue?vue&type=template&id=5d9f0ef0&scoped=true&"
import script from "./project-card.component.vue?vue&type=script&lang=ts&"
export * from "./project-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-card.component.vue?vue&type=style&index=0&id=5d9f0ef0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f0ef0",
  null
  
)

export default component.exports